export const DOCUMENTS_TAB = {
    reports: 'reports',
    files: 'files',
} as const;

export const DOCUMENTS_TABS_ORDER = [DOCUMENTS_TAB.reports, DOCUMENTS_TAB.files] as const;

export const DOCUMENTS_DEFAULT_TAB = DOCUMENTS_TAB.reports;
